export const timeout = (interval: number) => new Promise(resolve => setTimeout(resolve, interval))

export function createTimeoutPromise (duration: number, controller: AbortController): Promise<void> {
  return new Promise((_, reject) => {
    setTimeout(() => {
      controller.abort()
      reject(new Error('Timeout'))
    }, duration)
  })
}
